module.exports = "/fonts/fa-light-300.woff2?7cc3813fd8210dc22ed2cc16891d0c6d";